import { useQuery } from '@tanstack/react-query';
import { getPromotions } from '../Redux/util/Apis/promotions';

export const usePromotions = (options = {}) => {
  const { clientId } = options;

  return useQuery({
    queryKey: ['promotions', clientId],
    queryFn: async () => {
      const result = await getPromotions(clientId);

      if (result?.error) {
        throw new Error(result.message || 'Failed to fetch promotions');
      }

      return Array.isArray(result) ? result : [];
    },
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000
  });
};

export default usePromotions;
